import React from 'react';
import { Duration, secondsToDuration, durationToSeconds } from '../../../../types/task';
import { IOSFormGroup, IOSFormItem, IOSFormLabel, IOSFormNumberInput } from './IOSFormGroup';
import { useTranslation } from 'react-i18next';

interface IOSDurationInputProps {
  duration: Duration;
  onChange: (duration: Duration) => void;
  isDisabled?: boolean;
}

/**
 * iOS风格的时长输入组件
 */
export const IOSDurationInput: React.FC<IOSDurationInputProps> = ({
  duration,
  onChange,
  isDisabled = false
}) => {
  const { t } = useTranslation(['v3/ios', 'common']);
  // 处理时长变更
  const handleDurationChange = (field: keyof Duration, value: number) => {
    if (isNaN(value)) {
      value = 0;
    }

    const newDuration = { ...duration, [field]: value };
    onChange(newDuration);
  };

  return (
    <IOSFormGroup>
      <IOSFormItem>
        <IOSFormLabel className="block mb-2">{t('v3/ios:durationInput.label')}</IOSFormLabel>
        <div className="flex space-x-4">
          <div className="flex-1">
            <div className="text-xs text-ios-gray dark:text-ios-dark-gray mb-1">{t('common:time.days')}</div>
            <IOSFormNumberInput
              value={duration.days || 0}
              onChange={(value) => handleDurationChange('days', value)}
              min={0}
              max={365}
              disabled={isDisabled}
            />
          </div>
          <div className="flex-1">
            <div className="text-xs text-ios-gray dark:text-ios-dark-gray mb-1">{t('v3/ios:durationInput.hours')}</div>
            <IOSFormNumberInput
              value={duration.hours || 0}
              onChange={(value) => handleDurationChange('hours', value)}
              min={0}
              max={23}
              disabled={isDisabled}
            />
          </div>
          <div className="flex-1">
            <div className="text-xs text-ios-gray dark:text-ios-dark-gray mb-1">{t('v3/ios:durationInput.minutes')}</div>
            <IOSFormNumberInput
              value={duration.minutes || 0}
              onChange={(value) => handleDurationChange('minutes', value)}
              min={0}
              max={59}
              disabled={isDisabled}
            />
          </div>
        </div>
      </IOSFormItem>
    </IOSFormGroup>
  );
};
